export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const SET_PREV_STEP = 'SET_PREV_STEP';

export const CHOOSE_NEW_ACCOUNT_TYPE = 'CHOOSE_NEW_ACCOUNT_TYPE';
export const CHOOSE_EXIST_ACCOUNT_TYPE = 'CHOOSE_EXIST_ACCOUNT_TYPE';

export const SET_USER_FORM = 'SET_USER_FORM';

export const SET_MEDIA_INFO = 'SET_MEDIA_INFO';

// to
export const SET_LOGIN_FORM = 'SET_LOGIN_FORM';
// export const SET_USER_INFO = "SET_USER_INFO";
// export const SET_VERIFY_SMSCODE_STSTE = "SET_VERIFY_SMSCODE_STSTE";
export const SET_TIME_INFO = 'SET_TIME_INFO';
export const SET_IS_PHONE = 'SET_IS_PHONE';
